import { apiClient } from '../client'
import type {
  InventoryItem,
  CreateInventoryItemRequest,
  AdjustInventoryRequest,
  LowStockAlert,
  InventoryPageParams,
  InventoryPageResponse,
} from '../types/inventory'

export async function getInventoryItems(): Promise<InventoryItem[]> {
  const result = await getInventoryItemPage({ page: 0, size: 200 })
  return result.content
}

export async function getInventoryItemPage(
  params: InventoryPageParams = {}
): Promise<InventoryPageResponse> {
  const search = new URLSearchParams()
  search.set('page', String(params.page ?? 0))
  search.set('size', String(params.size ?? 20))
  if (params.keyword) search.set('keyword', params.keyword)
  if (params.lowStockOnly != null) search.set('lowStockOnly', String(params.lowStockOnly))
  return apiClient.get<InventoryPageResponse>(`/api/inventory/items?${search.toString()}`)
}

export async function getInventoryItem(skuCode: string): Promise<InventoryItem> {
  return apiClient.get<InventoryItem>(`/api/inventory/items/${skuCode}`)
}

export async function getInventoryLedger(skuCode: string): Promise<InventoryItem> {
  return apiClient.get<InventoryItem>(`/api/inventory/items/${skuCode}/ledger`)
}

export async function createInventoryItem(
  data: CreateInventoryItemRequest
): Promise<InventoryItem> {
  return apiClient.post<InventoryItem>('/api/inventory/items', data)
}

export async function adjustInventory(
  skuCode: string,
  data: AdjustInventoryRequest
): Promise<InventoryItem> {
  return apiClient.post<InventoryItem>(`/api/inventory/items/${skuCode}/adjust`, data)
}

export function calculateLowStockAlerts(items: InventoryItem[]): LowStockAlert[] {
  return items
    .filter((item) => item.availableQty < item.safetyStockQty)
    .map((item) => {
      const level: LowStockAlert['level'] = item.availableQty === 0 ? 'critical' : 'warning'
      return {
        skuCode: item.skuCode,
        partName: item.partName,
        currentQty: item.availableQty,
        safetyStockQty: item.safetyStockQty,
        shortage: item.safetyStockQty - item.availableQty,
        level,
      }
    })
    .sort((left, right) => right.shortage - left.shortage)
}
